import { i18n } from '../../i18n'

const state = {
  selectedLanguage: 'en',
  selectedChain: 'eos',
  showHeaderSearch: false,
  showSidebar: true,
  showSidebarXs: false,
  showSideOverlay: false,
  isLoading: false,
  isLoadingModal: false,
  network: {
    showSettings: false
  },
  showPpModal: false,
  loginToPath: undefined
}
const getters = {}
const actions = {
  toggleLoading ({ commit, state }) {
    if (state.isLoading) {
      commit('setLoading', false)
    } else commit('setLoading', true)
  }
}
const mutations = {
  changeLanguage (state, lang) {
    i18n.locale = lang
    localStorage.setItem('language', lang)
    state.selectedLanguage = lang
  },
  changeChain (state, chain) {
    state.selectedChain = chain
  },
  setLoginToPath (state, path) {
    state.loginToPath = path
  },
  toggleSearch (state) {
    state.showHeaderSearch = !state.showHeaderSearch
  },
  toggleSidebar (state) {
    state.showSidebar = !state.showSidebar
    state.showSidebarXs = !state.showSidebarXs
  },
  toggleSideOverlay (state) {
    state.showSideOverlay = !state.showSideOverlay
  },
  setLoading (state, payload) {
    state.isLoading = payload
  },
  setLoadingModal (state, payload) {
    state.isLoadingModal = payload
  },
  toggleShowSettings (state) {
    state.network.showSettings = !state.network.showSettings
  },
  togglePpModal (state, show) {
    state.showPpModal = show
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
